import { PDFDownloadLink } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";

export default function GenerateServicePDFPopup({ state, setState }) {
  const [loading, setLoading] = useState(true);
  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 200);
  // }, []);
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        state?.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
        <div className="flex justify-between items-center w-full">
          <h1 className="text-xl font-semibold">Download PDF</h1>
          {!loading && (
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setState((p) => ({ open: false }));
              }}
            >
              <IoMdClose />
            </h1>
          )}
        </div>
        <h2 className="text-sm">Generate and download PDF.</h2>
        <div className="w-full flex justify-center items-center mt-7">
          <button className="p-2 max-w-xs-ultra w-full rounded-md bg-red text-white justify-center text-sm">
            <PDFDownloadLink
              document={state?.component}
              fileName={state?.filename}
            >
              {(obj) => {
                return obj?.loading ? (
                  <p>
                    {setLoading(true)}
                    <LoadingWithLable
                      className={"!mt-0 text-white"}
                      text={"Loading PDF"}
                    />
                  </p>
                ) : (
                  <p>{setLoading(false)}Download PDF</p>
                );
              }}
            </PDFDownloadLink>
          </button>
        </div>
      </div>
    </div>
  );
}
